import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import * as actionTypes from "./store/actions";
import cloneDeep from "lodash/cloneDeep";
import secureStorage from "./helpers/locStore";

if (
  secureStorage.getItem("userdata") === "undefined" ||
  secureStorage.getItem("userdata") === null
) {
} else {
  let userdata = secureStorage.getItem("userdata");
  store.dispatch({
    type: actionTypes.UPDATE_USERDATA,
    payload: { userdata: userdata.userdata },
  });
}

if (
  secureStorage.getItem("cart") === undefined ||
  secureStorage.getItem("cart") === null
) {
  secureStorage.setItem("cart", { calculated_total: 0, items: [] });
  store.dispatch({
    type: actionTypes.SET_CART_ON_RELOAD,
    payload: { cart: { calculated_total: 0, items: [] } },
  });
} else {
  let cart = cloneDeep(secureStorage.getItem("cart"));

  store.dispatch({
    type: actionTypes.SET_CART_ON_RELOAD,
    payload: { cart: cart },
  });
}
console.log(store.getState());
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
